export const apiKey = 'AIzaSyBAZkTs75v00hxiwSMMhbY2Yn-DSDW2PYM';
export const mapId = '861ecca6f7d743d0';
export const defaultPostcode = '6000';
export const defaultPosition = {
  lat: -31.944178,
  lng: 115.877143,
};
export const defaultMarkerLabelOptions = {
  className: 'conv-maps-marker-label',
  fontFamily: '"Stevie Sans", sans-serif',
  fontSize: '18px',
  color: '#000F20',
};

// keeping map styles locally prevent it to have
// to load in client`s browser and flickering
// the rendering
const mapStyles = [
  {
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.land_parcel',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'administrative.neighborhood',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        lightness: 10,
      },
      {
        weight: 1,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
];

export const mapOptions = {
  zoom: 12,
  disableDefaultUI: true,
  overviewMapControl: false,
  overviewMapControlOptions: false,
  scrollwheel: false,
  gestureHandling: 'none',
  zoomControl: false,
  keyboardShortcuts: false,
  styles: mapStyles,
};
